<div class="title-box {{ titleSectionProp.class }}">
    <h2 class="{{ titleSectionProp.titleClass }}" *ngIf="titleSectionProp.title">{{ titleSectionProp.title }}</h2>
    <h4 class="{{ titleSectionProp.descClass }}" *ngIf="titleSectionProp.description">{{ titleSectionProp.description }}</h4>
</div>